"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var element = _ref.element;
  return "Could not export element (element type: " + element.elementType + ", id: " + element.id + ")";
};


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementExportStringFallback.js
// module id = 2265
// module chunks = 0